import React from 'react';
import styles from './WordCount.module.css';

interface WordCountProps {
  words: number;
  characters: number;
}

const WordCount: React.FC<WordCountProps> = ({ words, characters }) => {
  return (
    <div className={styles.wordCountContainer}>
      {[
        [words, 'Words'],
        [characters, 'Characters'],
      ].map(([count, label]) => (
        <div className={styles.wordCountRow} key={label}>
          <strong className={styles.count}>{count}</strong>
          <span className={styles.label}>{label}</span>
        </div>
      ))}
    </div>
  );
};

export default WordCount;
